<!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <v-container class="black--text" id="home-container">
    <banner></banner>

    <v-row no-gutters class="section1">
      <v-col
        cols="12"
        md="12"
        sm="12"
        class="alice d-flex flex-column justify-start wrap-fix"
      >
        <h1 class="pb-8">
          This here is a tag line to encourage people to apply to the recruit
          position.
        </h1>
        <h2 class="pb-1">
          This is a short list of things about the department.
        </h2>
        <h2 class="pt-0 pb-1">Another bit of info.</h2>
        <h2 class="pt-0 pb-0">And one more.</h2>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>

    <!--  position info section 1 -  -->
    <!-- flex-xs-column flex-lg-row -->
    <v-row no-gutters class="section3 d-flex">
      <v-col
        xs="12"
        sm="11"
        md="12"
        lg="3"
        class="alice d-flex flex-column wrap-fix s3col col-sx-12"
      >
        <div class="d-flex flex-column wrap-fix s3col pos-info">
          <h1 class="pb-0">the position</h1>
          <hr class="mb-1 mt-n3" />
          <hr class="mb-4" />
          <div class="picHolder1">
            <h2>A PICTURE GOES HERE</h2>
          </div>

          <v-btn
            v-on:click="message1"
            color="accent"
            class="mt-n2 posInfo align-self-center"
            >Job Details</v-btn
          >

          <h3 class="pb-1">
            A short descriptive paragraph here about the position. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </h3>

          <router-view></router-view>
        </div>
      </v-col>

      <!--  position info section 2 -->
      <v-col
        lg="3"
        sm="11"
        md="12"
        xs="12"
        class="alice d-flex flex-column wrap-fix s3col"
      >
        <div class="d-flex flex-column wrap-fix s3col pos-info">
          <h1 class="pb-0">the process</h1>
          <hr class="mb-1 mt-n3" />
          <hr class="mb-4" />
          <div class="picHolder1">
            <h2>A PICTURE GOES HERE</h2>
          </div>

          <v-btn
            v-on:click="message1"
            color="accent"
            class="mt-n2 posInfo align-self-center"
            >Learn More</v-btn
          >

          <h3 class="pb-1">
            A short descriptive paragraph here about the process. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </h3>

          <router-view></router-view>
        </div>
      </v-col>

      <!--  position info SECTION3-  -->
      <v-col
        lg="3"
        sm="11"
        md="12"
        xs="12"
        class="alice d-flex flex-column wrap-fix s3col"
      >
        <div class="d-flex flex-column wrap-fix s3col pos-info">
          <h1 class="pb-0">the requirements</h1>
          <hr class="mb-1 mt-n3" />
          <hr class="mb-4" />
          <div class="picHolder1">
            <h2>A PICTURE GOES HERE</h2>
          </div>

          <v-btn
            v-on:click="message1"
            color="accent"
            class="mt-n2 posInfo align-self-center"
            >See testing info</v-btn
          >

          <h3 class="pb-1">
            A short descriptive paragraph here about getting the requirements.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt.
          </h3>

          <router-view></router-view>
        </div>
      </v-col>

      <!--  position info SECTION4 -  -->
      <v-col
        lg="3"
        sm="11"
        md="12"
        xs="12"
        class="alice d-flex flex-column wrap-fix s3col"
      >
        <div class="d-flex flex-column wrap-fix s3col pos-info">
          <h1 class="pb-0">apply</h1>
          <hr class="mb-1 mt-n3" />
          <hr class="mb-4" />
          <div class="picHolder1">
            <h2>A PICTURE GOES HERE</h2>
          </div>

          <v-btn
            v-on:click="message1"
            color="accent"
            class="mt-n2 posInfo align-self-center"
            >Get started now</v-btn
          >

          <h3 class="pb-1">
            A short descriptive paragraph here about how to apply. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </h3>

          <router-view></router-view>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  .alice {
    color: aliceblue;
  }

  .section1 {
    background-image: url("../images/small-place-holder-346.png");
    height: 425px;
  }

  .section3 {
    background-color: #344e6b;
    flex-direction: column;
  }

  .section1 span,
  .section1 h1,
  .section1 h2,
  .section2 h1,
  .section2 h2,
  .section2 h3,
  .section3 h1,
  .section3 h2,
  .section3 h3 {
    padding: 5%;
    text-shadow: 2px 2px 4px #000000;
  }

  .section1 h2,
  .section2 h2 {
    font-weight: 300;
  }

  .section3 h3 {
    font-family: math;
    font-weight: 300;
  }

  .section3 hr {
    border-color: #ccb159;
    background-color: #ccb159;
  }

  .section3 .spacer {
    width: 0;
    flex-grow: 0 !important;
  }

  .s3col {
    justify-content: flex-start;
  }

  .pos-info {
    width: 100%;
    flex-direction: column;
  }

  .picHolder1 {
    height: 242px;
    background-color: darkgrey;
  }

  .posInfo {
    opacity: 0.9;
  }

  .whats-next .v-btn {
    width: 75%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    background-color: transparent;
    background-image: none;
    background-size: cover;
  }

  .med-marg {
    margin-left: -30%;
  }

  .section3 {
    flex-direction: column;
  }

  .s3col {
    align-self: center;
  }

  .whats-next .v-btn {
    width: 33%;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    background-image: none;
  }

  .med-marg {
    margin-left: 0;
  }

  .pos-info {
    width: 80%;
    flex-direction: row;
  }

  .section3 {
    flex-direction: row;
    justify-content: center;
    flex-wrap: nowrap;
  }

  .section3 .spacer {
    width: 50px;
  }
  .s3col {
    justify-content: space-between;
  }

  .whats-next {
    margin-top: 10%;
  }
}

@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
export default {
  name: "postion1",
  components: {
    banner,
  },
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert(
        "This button will take the user to a page with more detailed info."
      );
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
